const CustomErrorCodes = {
  BAD_GATEWAY_ERROR: 502,
  SERVICE_UNAVAILABLE_ERROR: 503,
  GATEWAY_TIMEOUT_ERROR: 504,
  // device not found
  OverconstrainedError: 0,
  // config errors(1000-1100)
  CONFIG_NOT_PROVIDED: 1001,
  CONFIG_VALIDATION_FAILED: 1002,
  CONFIG_FILE_NOT_FOUND: 1003,
  CONFIG_FILE_READ_ERROR: 1004,
  CONFIG_PERMISSION_ERROR: 1005,
  CONFIG_MISSING_REQUIRED_PARAMETER: 1006,
  CONFIG_INCOMPATIBLE_WITH_SERVICE_VERSION: 1007,
  CONFIG_REQUEST_FAILED: 1008,

  // service errors(1000-1100)
  SERVICE_NOT_AVAILABLE: 1101,
  SERVICE_ALREADY_RUNNING: 1102,
  SERVICE_NOT_RUNNING: 1103,
  SERVICE_FAILED_TO_START: 1104,
  SERVICE_FAILED_TO_STOP: 1105,
  SERVICE_INVALID_REQUEST: 1106,
  SERVICE_AUTHENTICATION_FAILURE: 1107,
  SERVICE_UPGRADE_REQUIRED: 1108,
  SERVICE_RATE_LIMIT_EXCEEDED: 1109,
  SERVICE_INTERNAL_ERROR: 1110,
  SERVICE_FAILED_TO_INIT: 1111,

  //callback errors(1201-1250)
  CALLBACK_NOT_PROVIDED: 1201,
  CALLBACK_ARGUMENT_ERROR: 1202,
  CALLBACK_EXECUTION_FAILED: 1203,

  //Machine Check erros - (2701 - 2800)
  VIRTUAL_MACHINE_DETECTED: 2701,
  RDP_CONNECTION_DETECTED: 2702,

  //DISPLAY CHECKS - (2801 - 2851)
  VIRTUAL_DESKTOPS: 2802,

  //UNKNOWN APP DETECTION - (2852 - 2900)
  UNKNOWN_APP_DETECTED: 2852,
  // Browser error -(2001-2100)
  BROWSER_NOT_SUPPORTED: 2001,
  BROWSER_VERSION_NOT_SUPPORTED: 2002,
  BROWSER_NOT_COMPATIBLE: 2003,
  BROWSER_PERMISSION_ERROR: 2004,
  BROWSER_CAMERA_PERMISSION_NOT_GRANTED: 2005,
  BROWSER_MICROPHONE_PERMISSION_NOT_GRANTED: 2006,
  BROWSER_WINDOW_MANAGEMENT_PERMISSION_NOT_GRANTED: 2007,
  BROWSER_OPERATING_SYSTEM_NOT_SUPPORTED: 2008,
  RAM_CONDITION_NOT_MET: 2009,
  OPERATING_SYSTEM_NOT_SUPPORTED: 2010,

  START_BROWSER_PERMISSION_CHANGE_DETECTION_ERROR: 2051,
  STOP_BROWSER_PERMISSION_CHANGE_DETECTION_ERROR: 2052,
  GET_BROWSER_PERMISSION_STATUS_ERROR: 2053,
  GET_SYSTEM_METADATA_ERROR: 2054,

  //Internet-connectivity errors-(2101-2150)
  INTERNET_INSUFFICIENT_BANDWIDTH_ERROR: 2101,
  INTERNET_OFFLINE: 2102,

  //Screenshare errors-(2151-2200)
  MULTIPLE_SCREENS_DETECTION_ERROR: 2151,
  MULTIPLE_SCREEN_VIOLATION: 2152,
  MULTIPLE_SCREEN_DETECTED: 2153,
  STOPPING_SCREEN_DETECTION_ERROR: 2154,
  SCREEN_CHANGE_HANDLER_ERROR: 2155,
  START_SCREEN_SHARE_VIDEO_ERROR: 2156,
  REQUEST_SCREEN_SHARE_STREAM_ERROR: 2157,
  FULL_SCREEN_NOT_SHARED_ERROR: 2458,
  VALID_SCREEN_NOT_SHARED_ERROR: 2159,
  SCREEN_SHARE_DENIED_ERROR: 2160,

  //Webcam errors-(2201-2300)
  START_WEBCAM_VIDEO_ERROR: 2201,
  REQUEST_WEBCAM_MEDIA_STREAM_ERROR: 2202,
  WEBCAM_PERMISSION_DENIED: 2203,
  WEBCAM_NOT_FOUND: 2204,
  WEBCAM_NOT_READABLE: 2205,
  WEBCAM_ALREADY_IN_USE: 2206,
  WEBCAM_RESOLUTION_REQUIREMENT_NOT_MET: 2207,

  //Hardware Acceleration error-(2301-2325)
  HARDWARE_ACCELERATION_NOT_ENABLED: 2301,
  WEBGL_NOT_SUPPORTED: 2302,
  WEBGL_RENDERING_NOT_ENABLED: 2303,

  //Additional Steps error-(2326-2350)
  STEPS_FAILED_FOR_ADDITIONAL_CHECKS: 2301,

  //Microphone Check errors-(2351-2400)
  REQUEST_AUDIO_STREAM_ERROR: 2351,
  MICROPHONE_PERMISSION_DENIED: 2352,
  MICROPHONE_NOT_FOUND: 2353,
  MICROPHONE_NOT_READABLE: 2354,
  MICROPHONE_AUDIO_NOT_DETECTED: 2355,
  MICROPHONE_AUDIO_STREAM_DETECTED_WITH_NO_AUDIO: 2356,
  MICROPHONE_SPEECH_RECOGNITION_FAILED: 2357,
  MICROPHONE_AUDIO_STREAM_NOT_AVAILABLE: 2358,

  //Extensions errors-(2401-2450)
  EXTENSIONS_DETECTED: 2401,

  //Compatibility errors-(2501-2600)
  DETECT_SYSTEM_COMPATIBILITY_ERROR: 2501,
  BOWSER_NOT_FOUND: 2502,
  GET_PARSER_NOT_DEFINED: 2503,
  INCORRECT_CONFIG: 2504,
  COMPATIBLE_BROWSERS_MISSING: 2505,

  //Devices errors-(2601-2700)
  ENUMERATE_DEVICES_ERROR: 2601,
  DEVICE_NOT_IN_WINDOW: 2602,
  DEVICE_TYPE_NOT_GIVEN: 2603,

  //Auto-proctoring errors-(3001-4000)
  AUTO_PROCTORING_WEBCAM_DISCONNECTED_ERROR: 3001,
  AUTO_PROCTORING_MICROPHONE_DISCONNECTED_ERROR: 3002,
  AUTO_PROCTORING_SCREENSHARE_STOPPED_ERROR: 3003,
  AUTO_PROCTORING_BROWSER_PERMISSION_TOGGLE_ERROR: 3004,

  FAILED_TO_GET_ORGANIZATION_DETAILS: 3005,
  FAILED_TO_GET_CLIENT_USER_MAPPING: 3006,
  FAILED_TO_GET_TEST_DETAILS_FROM_USER_GUID: 3007,
  FAILED_TO_GET_TEST_DETAILS_FROM_CLIENT_TEST_GUID: 3008,
  FAILED_TO_SET_PROCTOR_SESSION: 3009,
  AUTO_PROCTORING_FAILED_TO_ADD_CANDIDATE_FOR_MANUAL_PROCTORING: 3010,

  CHECK_INSPECT_WINDOW_OPEN_ERROR: 3101,
  GET_SCROLL_BAR_WIDTH_ERROR: 3102,
  CHECK_WINDOW_RESIZED_ERROR: 3103,
  TAB_SWITCH_HANDLER_ERROR: 3104,
  START_TAB_SWITCH_DETECTION_ERROR: 3105,
  STOP_TAB_SWITCH_DETECTION_ERROR: 3106,

  AUTO_PROCTORING_NOT_INITIALIZED: 3501,
  AUTO_PROCTORING_SELECTOR_NOT_PROVIDED: 3502,

  FAILED_TO_GENERATE_REPORT: 3600,

  //Chat-tool errors-(4001-5000)
  CHAT_UI_TOOL_NOT_INITIALIZED: 4001,
  CHAT_UI_TOOL_SELECTOR_NOT_PROVIDED: 4002,

  FAQ_SDK_NOT_INITIALIZED: 4501,
  FAQ_SDK_SELECTOR_NOT_PROVIDED: 4502,

  //Verification-steps-sdk errors-(5001-5500)
  //TODO: Need to update the error codes for verification steps sdk
  VERIFICATIONS_STEPS_SDK_NOT_INITIALIZED: 3501,
  VERIFICATIONS_STEPS_SDK_SELECTOR_NOT_PROVIDED: 3502,

  //Unexpected Error Occured due to missing error Codes-(5501-6000)
  UNEXPECTED_ERROR_OCCURED: 5501,

  //Report-sdk-(6001-7000)
  REPORT_SDK_NOT_INITIALISED: 6001,
  REPORT_SDK_SELECTOR_NOT_PROVIDED: 6002,

  //Proctoring-setting-sdk(7001-8000)
  PROVIDED_TEST_GUID_IS_NOT_MAPPED_ON_TESTMAVERICK_DATABASE: 7001,
  PROVIDED_DATE_IS_NOT_IN_CORRECT_FORMAT: 7002,
  PROVIDED_TESTGUID_IS_INCORRECT: 7003,
  PROVIDED_PROCTORING_MODE_IS_INCORRECT: 7004,
  TEST_GUID_IS_NOT_PROVIDED: 7005,
  CANNOT_RESET_TEST_AFTER_THE_TEST_START_TIME: 7006,
  PROCTORING_SETTINGS_TOOL_NOT_INITIALIZED: 7007,
  PROCTORING_SETTINGS_TOOL_SELECTOR_NOT_PROVIDED: 7008,
  TEST_START_TIME_SHOULD_BE_EARLIER_THAN_TEST_END_TIME: 7009,
  ENTER_A_VALID_NUMBER_FOR_EXPECTED_CANDIDATES: 7010,
  ENTERED_NUMBER_EXCEEDS_MAXIMUM_ALLOWED_CANDIDATES: 7011,

  // Sentry
  SENTRY_INIT_ERROR: 8001,

  // indexedDb
  INDEXED_DB_FAILED_TO_INITIALIZE: 9001,
  INDEXED_DB_FAILED_TO_START: 9002,
  INDEXED_DB_FAILED_TO_STOP: 9003,
  INDEXED_DB_FAILED_TO_SAVE: 9004,

  LIVE_STREAMING_FAILED_TO_INITIALIZE: 10001,
  LIVE_STREAMING_FAILED_TO_START: 10002,
  LIVE_STREAMING_FAILED_TO_STOP: 10003,
  LIVE_STREAMING_FAILED_TO_ADD_LISTENERS: 10004,
  LIVE_STREAMING_FAILED_TO_REMOVE_LISTENERS: 10005,

  LIVE_STREAMING_FAILED_TO_LISTEN_TO_MEDIA_START_REQUEST: 10006,
  LIVE_STREAMING_FAILED_TO_LISTEN_TO_MEDIA_STOP_REQUEST: 10007,
  LIVE_STREAMING_FAILED_TO_SEND_MEDIA_START_REQUEST: 10008,
  LIVE_STREAMING_FAILED_TO_SEND_MEDIA_STOP_REQUEST: 10009,
  LIVE_STREAMING_FAILED_TO_REMOVE_MEDIA_START_REQUEST_LISTENER: 10010,
  LIVE_STREAMING_FAILED_TO_REMOVE_MEDIA_STOP_REQUEST_LISTENER: 10011,

  LIVE_STREAMING_FAILED_TO_LISTEN_TO_PEER_OFFER: 10012,
  LIVE_STREAMING_FAILED_TO_LISTEN_TO_PEER_ANSWER: 10013,
  LIVE_STREAMING_FAILED_TO_SEND_PEER_OFFER: 10014,
  LIVE_STREAMING_FAILED_TO_SEND_PEER_ANSWER: 10015,
  LIVE_STREAMING_FAILED_TO_REMOVE_PEER_OFFER_LISTENER: 10016,
  LIVE_STREAMING_FAILED_TO_REMOVE_PEER_ANSWER_LISTENER: 10017,

  LIVE_STREAMING_FAILED_TO_LISTEN_TO_ICE_CANDIDATES: 10018,
  LIVE_STREAMING_FAILED_TO_SEND_ICE_CANDIDATES: 10019,
  LIVE_STREAMING_FAILED_TO_REMOVE_ICE_CANDIDATES_LISTENER: 10020,

  LIVE_STREAMING_FAILED_TO_CREATE_PEER_CONNECTION: 10018,
  LIVE_STREAMING_FAILED_TO_CLOSE_PEER_CONNECTION: 10019,
  LIVE_STREAMING_FAILED_TO_SET_LOCAL_DESCRIPTION: 10020,
  LIVE_STREAMING_FAILED_TO_SET_REMOTE_DESCRIPTION: 10020,
  LIVE_STREAMING_FAILED_TO_ADD_MEDIA_TRACK: 10020,
  LIVE_STREAMING_FAILED_TO_REMOVE_MEDIA_TRACK: 10020,
  //FORCE_SUBMITTED
  TEST_FORCE_SUBMITTED: 11001,

  //PI Data issues
  PI_DATA_NOT_FOUND: 12000,
  USER_DETAILS_NOT_FOUND: 12001
};
export default CustomErrorCodes;
